module.exports = "/_next/static/images/esquire-56b88100007f0517ca41fea39ad2f13a.png";